export default "__VITE_ASSET__Bdq4rq5J__"